
import { Organization } from '@/models/Organization';
import {Component, Prop, Vue} from 'vue-property-decorator';
import PassengerSearch from '@/components/PassengerSearch.vue';
import GroupPicker from '@/components/Passenger/components/GroupPicker.vue';
import DestinationSelector from '@/components/Passenger/components/DestinationSelector.vue';
import { debounce } from '@/util/debounce';
import Group from '@/components/Passenger/models/Group';

export interface RideitInvitationFilterFormData {
  passengerSearch: string;
  destinationId: number | null;
  tag: string;
}

@Component({
  components: {
    PassengerSearch,
    GroupPicker,
    DestinationSelector,
  }
})
export default class RideitInvitationFilterForm extends Vue {

  organization: Organization = this.getOrganization();

  // Debounce passenger search input to avoid excessive updates while typing
  debouncedPassengerSearch = debounce(this.updatePassengerSearch, 500);

  @Prop({}) private value: RideitInvitationFilterFormData;
  @Prop({ default: () => [] }) private groups: Group[];

  get passengerSearch() {
    return this.value.passengerSearch;
  }
  set passengerSearch(newValue: string) {
    this.debouncedPassengerSearch(newValue);
  }

  get destinationId() {
    return this.value.destinationId;
  }
  set destinationId(newValue: number | null) {
    this.updateValue({ ...this.value, destinationId: newValue });
  }

  get tag() {
    return this.value.tag;
  }
  set tag(newValue: any) {
    console.log('Selected tag:', newValue);
    this.updateValue({ ...this.value, tag: newValue });
  }

  getSelectedGroups() {
    if (!this.tag) {
      return [];
    }
    const selectedGroupNames = this.tag.split(',').map((t: string) => t.trim());
    return this.groups.filter(g => selectedGroupNames.includes(g.name));
  }

  onTagChange(groups: Group[]) {
    this.tag = groups.map(g => g.name).join(',');
  }

  updatePassengerSearch(newValue: string) {
    this.updateValue({ ...this.value, passengerSearch: newValue });
  }
  
  getOrganization() {
    const organizationId = this.$route.params.organizationId;
    return this.$store.state.organization.organizations.find((o: Organization) => o.id === organizationId);
  }

  updateValue(newValue: RideitInvitationFilterFormData) {
    this.$emit('input', newValue);
  }
}
